import { Injectable } from '@angular/core';
import * as _ from 'lodash';
import { SharedService } from './shared.service';

@Injectable()
export class CallbacksService {
  constructor(public sharedService: SharedService) {}

  validateNoEmptyCallbacks(callbacks: Array<any>) {
    const emptyCallbacks: Array<boolean> = _.filter(callbacks, (callback: any) => {
      return callback.url.split(' ').join('').length === 0;
    });
    return emptyCallbacks.length === 0;
  }

  validatCallbacksURLs(callbacks: Array<any>) {
    let answer = true;
    let index = 0;
    while (answer && index < callbacks.length) {
      answer = this.sharedService.validateURL(callbacks[index].url);
      index++;
    }
    return answer;
  }

  validateIVTCallbacks(callbacks: Array<any>) {
    const jsCallbackDomains: Array<string> = _.map(this.sharedService.jsCallbackDomains, 'domain');
    let answer = true;
    let index = 0;
    let currURL: string;
    while (answer && index < callbacks.length) {
      if (callbacks[index].event.typeId === 1) {
        currURL = callbacks[index].url;
        currURL = currURL.replace('http://', '');
        currURL = currURL.replace('https://', '');
        if (currURL.indexOf('/') > -1) {
          currURL = currURL.substr(0, currURL.indexOf('/'));
        }
        while (currURL.indexOf('.') !== currURL.lastIndexOf('.')) {
          currURL = currURL.substr(currURL.indexOf('.') + 1, currURL.length);
        }
        currURL = currURL.trim();
        answer = jsCallbackDomains.includes(currURL);
      }
      index++;
    }
    return answer;
  }

  validateUniqueCallbacks(callbacks: Array<any>) {
    const uniqueCallbacks: Array<any> = _.uniqBy(callbacks, (callback: any) => {
      return [callback.url, callback.event.eventId].join();
    });
    return uniqueCallbacks.length === callbacks.length;
  }

  validateCallbacksRates(callbacks: Array<any>) {
    return (
      _.filter(callbacks, (callback: any) => {
        return (callback.rate <= 0 || callback.rate > 100) && callback.event.typeId === 1;
      }).length === 0
    );
  }
}
